import bigRibbonRed from '../images/ribbons/bigRibbonColors/bigRibbonRed.svg';
import bigRibbonLightBlue from '../images/ribbons/bigRibbonColors/bigRibbonLightBlue.svg';
import bigRibbonSage from '../images/ribbons/bigRibbonColors/bigRibbonSage.svg';
import bigRibbonHotPink from '../images/ribbons/bigRibbonColors/bigRibbonHotPink.svg';
import bigRibbonPink from '../images/ribbons/bigRibbonColors/bigRibbonPink.svg';
import bigRibbonLilac from '../images/ribbons/bigRibbonColors/bigRibbonLilac.svg';

import ribbonSpoolRed from '../images/ribbons/ribbonSpoolColors/ribbonSpoolRed.svg';
import ribbonSpoolLightBlue from '../images/ribbons/ribbonSpoolColors/ribbonSpoolLightBlue.svg';
import ribbonSpoolSage from '../images/ribbons/ribbonSpoolColors/ribbonSpoolSage.svg';
import ribbonSpoolHotPink from '../images/ribbons/ribbonSpoolColors/ribbonSpoolHotPink.svg';
import ribbonSpoolPink from '../images/ribbons/ribbonSpoolColors/ribbonSpoolPink.svg';
import ribbonSpoolLilac from '../images/ribbons/ribbonSpoolColors/ribbonSpoolLilac.svg';

import smallRibbonRed from '../images/ribbons/smallRibbonColors/smallRibbonRed.svg';
import smallRibbonWhite from '../images/ribbons/smallRibbonColors/smallRibbonWhite.svg';
import smallRibbonHotPink from '../images/ribbons/smallRibbonColors/smallRibbonHotPink.svg';
import smallRibbonLightBlue from '../images/ribbons/smallRibbonColors/smallRibbonLightBlue.svg';
import smallRibbonLilac from '../images/ribbons/smallRibbonColors/smallRibbonLilac.svg';
import smallRibbonPink from '../images/ribbons/smallRibbonColors/smallRibbonPink.svg';
import smallRibbonSage from '../images/ribbons/smallRibbonColors/smallRibbonSage.svg';
import smallRibbonYellow from '../images/ribbons/smallRibbonColors/smallRibbonYellow.svg';

import smallRibbonSpoolRed from '../images/ribbons/smallRibbonSpoolColors/smallRibbonSpoolRed.svg';
import smallRibbonSpoolWhite from '../images/ribbons/smallRibbonSpoolColors/smallRibbonSpoolWhite.svg';
import smallRibbonSpoolHotPink from '../images/ribbons/smallRibbonSpoolColors/smallRibbonSpoolHotPink.svg';
import smallRibbonSpoolLightBlue from '../images/ribbons/smallRibbonSpoolColors/smallRibbonSpoolLightBlue.svg';
import smallRibbonSpoolLilac from '../images/ribbons/smallRibbonSpoolColors/smallRibbonSpoolLilac.svg';
import smallRibbonSpoolPink from '../images/ribbons/smallRibbonSpoolColors/smallRibbonSpoolPink.svg';
import smallRibbonSpoolSage from '../images/ribbons/smallRibbonSpoolColors/smallRibbonSpoolSage.svg';
import smallRibbonSpoolYellow from '../images/ribbons/smallRibbonSpoolColors/smallRibbonSpoolYellow.svg';

import smallRibbon from '../images/ribbons/smallRibbon.svg';
import bigRibbon from '../images/ribbons/bigRibbon.svg';

import ribbonSpool from '../images/ribbons/ribbonSpool.svg';
import smallRibbonSpool from '../images/ribbons/smallRibbonSpool.svg';

const ribbons = [ 
    {
        "name": "pink ribbon",
        "src": bigRibbonPink, 
        "outlineSrc": bigRibbon,
        "spoolSrc": ribbonSpool,
        "spoolColorSrc": ribbonSpoolPink,
        "alt": "large pink ribbon",
        "buildClass": "ribbonColor",
        "outlineClass": "ribbon ribbonLarge",
        "spoolClass": "ribbonSpool",
        "type": "big"
    },
    {
        "name": "hot pink ribbon",
        "src": bigRibbonHotPink, 
        "outlineSrc": bigRibbon,
        "spoolSrc": ribbonSpool,
        "spoolColorSrc": ribbonSpoolHotPink,
        "alt": "large hot pink ribbon",
        "buildClass": "ribbonColor",
        "outlineClass": "ribbon ribbonLarge",
        "spoolClass": "ribbonSpool",
        "type": "big"
    },
    {
        "name": "red ribbon",
        "src": bigRibbonRed, 
        "outlineSrc": bigRibbon,
        "spoolSrc": ribbonSpool,
        "spoolColorSrc": ribbonSpoolRed,
        "alt": "large red ribbon",
        "buildClass": "ribbonColor",
        "outlineClass": "ribbon ribbonLarge",
        "spoolClass": "ribbonSpool",
        "type": "big"
    },

    {
        "name": "small pink ribbon",
        "src": smallRibbonPink, 
        "outlineSrc": smallRibbon,
        "spoolSrc": smallRibbonSpool,
        "spoolColorSrc": smallRibbonSpoolPink,
        "alt": "small pink ribbon",
        "buildClass": "smallRibbonColor",
        "outlineClass": "ribbon ribbonSmall",
        "spoolClass": "smallRibbonSpool",
        "type": "small"
    },
    {
        "name": "small lilac ribbon",
        "src": smallRibbonLilac, 
        "outlineSrc": smallRibbon,
        "spoolSrc": smallRibbonSpool,
        "spoolColorSrc": smallRibbonSpoolLilac,
        "alt": "small lilac ribbon",
        "buildClass": "smallRibbonColor",
        "outlineClass": "ribbon ribbonSmall",
        "spoolClass": "smallRibbonSpool",
        "type": "small"
    },
    {
        "name": "hot pink small ribbon",
        "src": smallRibbonHotPink, 
        "outlineSrc": smallRibbon,
        "spoolSrc": smallRibbonSpool,
        "spoolColorSrc": smallRibbonSpoolHotPink,
        "alt": "hot pink small ribbon",
        "buildClass": "smallRibbonColor",
        "outlineClass": "ribbon ribbonSmall",
        "spoolClass": "smallRibbonSpool",
        "type": "small"
    },
    {
        "name": "small red ribbon",
        "src": smallRibbonRed, 
        "outlineSrc": smallRibbon,
        "spoolSrc": smallRibbonSpool,
        "spoolColorSrc": smallRibbonSpoolRed,
        "alt": "small red ribbon",
        "buildClass": "smallRibbonColor",
        "outlineClass": "ribbon ribbonSmall",
        "spoolClass": "smallRibbonSpool",
        "type": "small"
    },
    {
        "name": "light blue ribbon",
        "src": bigRibbonLightBlue, 
        "outlineSrc": bigRibbon,
        "spoolSrc": ribbonSpool,
        "spoolColorSrc": ribbonSpoolLightBlue,
        "alt": "large light blue ribbon",
        "buildClass": "ribbonColor",
        "outlineClass": "ribbon ribbonLarge",
        "spoolClass": "ribbonSpool",
        "type": "big"
    },
    {
        "name": "lilac ribbon",
        "src": bigRibbonLilac, 
        "outlineSrc": bigRibbon,
        "spoolSrc": ribbonSpool,
        "spoolColorSrc": ribbonSpoolLilac,
        "alt": "large lilac ribbon",
        "buildClass": "ribbonColor",
        "outlineClass": "ribbon ribbonLarge",
        "spoolClass": "ribbonSpool",
        "type": "big"
    },
    {
        "name": "sage ribbon",
        "src": bigRibbonSage, 
        "outlineSrc": bigRibbon,
        "spoolSrc": ribbonSpool,
        "spoolColorSrc": ribbonSpoolSage,
        "alt": "large sage ribbon",
        "buildClass": "ribbonColor",
        "outlineClass": "ribbon ribbonLarge",
        "spoolClass": "ribbonSpool",
        "type": "big"
    },

    {
        "name": "light blue ribbon",
        "src": smallRibbonLightBlue, 
        "outlineSrc": smallRibbon,
        "spoolSrc": smallRibbonSpool,
        "spoolColorSrc": smallRibbonSpoolLightBlue,
        "alt": "small light blue ribbon",
        "buildClass": "smallRibbonColor",
        "outlineClass": "ribbon ribbonSmall",
        "spoolClass": "smallRibbonSpool",
        "type": "small"
    },
    {
        "name": "small white ribbon",
        "src": smallRibbonWhite, 
        "outlineSrc": smallRibbon,
        "spoolSrc": smallRibbonSpool,
        "spoolColorSrc": smallRibbonSpoolWhite,
        "alt": "small white ribbon",
        "buildClass": "smallRibbonColor",
        "outlineClass": "ribbon ribbonSmall",
        "spoolClass": "smallRibbonSpool",
        "type": "small"
    },
    {
        "name": "small sage ribbon",
        "src": smallRibbonSage, 
        "outlineSrc": smallRibbon,
        "spoolSrc": smallRibbonSpool,
        "spoolColorSrc": smallRibbonSpoolSage,
        "alt": "small sage ribbon",
        "buildClass": "smallRibbonColor",
        "outlineClass": "ribbon ribbonSmall",
        "spoolClass": "smallRibbonSpool",
        "type": "small"
    },
    {
        "name": "small yellow ribbon",
        "src": smallRibbonYellow, 
        "outlineSrc": smallRibbon,
        "spoolSrc": smallRibbonSpool,
        "spoolColorSrc": smallRibbonSpoolYellow,
        "alt": "small yellow ribbon",
        "buildClass": "smallRibbonColor",
        "outlineClass": "ribbon ribbonSmall",
        "spoolClass": "smallRibbonSpool",
        "type": "small"
    },
]

export default ribbons;